import { IAppState } from '../../redux';

export const selectPrice = (state: IAppState) => {
  const { offer } = state;

  return offer.bargainTerms.price;
};
